import React from "react";

const Testimonials = () => {
  return (
    <div className="bg-white py-10">
      <h1 className="text-2xl font-semibold text-center mb-8">
      What Our Clients Are Saying
      </h1>
      <div className="container mx-auto flex flex-wrap justify-between gap-4">
        <div className="bg-gray-100 p-6 rounded-lg shadow-md max-w-md mx-auto text-center relative h-56">
          <p className="text-l text-gray-800 mb-4 pt-4 p-4">
            “I was incredibly impressed with Grow Home Studio's ability to
            transform my space into a beautiful and functional oasis”
          </p>
          <p className="text-[#D78F00] font-medium absolute bottom-4 right-6 p-2">
            - Deepthi Kanaganti
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-md max-w-md mx-auto text-center relative h-56">
          <p className="text-l text-gray-800 mb-4 pt-4 p-4">
            “Grow Home Studio exceeded my expectations with their attention to
            detail and innovative designs.”
          </p>
          <p className="text-[#D78F00] font-medium absolute bottom-4 right-6 p-2">
            - Venkatesh Perla
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-md max-w-md mx-auto text-center relative h-56 overflow-hidden">
          <p className="text-l text-gray-800 mb-4 pt-4 p-4">
            “The team at Grow Home Studio is professional, creative, and highly
            skilled.”
          </p>
          <p className="text-[#D78F00] font-medium absolute bottom-4 right-6 p-2">
            - Kishan Singh Rana
          </p>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
